import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import './InfoPages.css';

function HelpCenter() {
  const { t } = useTranslation();
  const [openId, setOpenId] = useState(null);

  const faqItems = [
    {
      category: t('infoPages.helpCenter.buying'),
      questions: [
        {
          q: t('infoPages.helpCenter.howContactSeller'),
          a: t('infoPages.helpCenter.howContactSellerAnswer'),
        },
        {
          q: t('infoPages.helpCenter.knowTrustworthy'),
          a: t('infoPages.helpCenter.knowTrustworthyAnswer'),
        },
      ],
    },
    {
      category: t('infoPages.helpCenter.selling'),
      questions: [
        {
          q: t('infoPages.helpCenter.howPostAd'),
          a: t('infoPages.helpCenter.howPostAdAnswer'),
        },
        {
          q: t('infoPages.helpCenter.howBoostAd'),
          a: t('infoPages.helpCenter.howBoostAdAnswer'),
        },
      ],
    },
    {
      category: t('infoPages.helpCenter.account'),
      questions: [
        {
          q: t('infoPages.helpCenter.howResetPassword'),
          a: t('infoPages.helpCenter.howResetPasswordAnswer'),
        },
        {
          q: t('infoPages.helpCenter.howDeleteAccount'),
          a: t('infoPages.helpCenter.howDeleteAccountAnswer'),
        },
      ],
    },
    {
      category: t('infoPages.helpCenter.safety'),
      questions: [
        {
          q: t('infoPages.helpCenter.suspiciousAd'),
          a: t('infoPages.helpCenter.suspiciousAdAnswer'),
        },
        {
          q: t('infoPages.helpCenter.safePayAdvance'),
          a: t('infoPages.helpCenter.safePayAdvanceAnswer'),
        },
      ],
    },
  ];

  const toggle = (id) => {
    setOpenId((prev) => (prev === id ? null : id));
  };

  let id = 0;
  return (
    <div className="infoPage">
      <Header />
      <div className="infoPageLayout">
        <div className="infoHero">
          <h1>{t('infoPages.helpCenter.title')}</h1>
          <p>{t('infoPages.helpCenter.description')}</p>
        </div>

        <div className="infoSection">
          <h2>{t('infoPages.helpCenter.searchTips')}</h2>
          <p>{t('infoPages.helpCenter.searchTipsDesc')}</p>
        </div>

        <div className="infoSection">
          <h2>{t('infoPages.helpCenter.faq')}</h2>
          {faqItems.map(({ category, questions }) => (
            <div key={category}>
              <h3>{category}</h3>
              {questions.map(({ q, a }) => {
                const currentId = ++id;
                const isOpen = openId === currentId;
                return (
                  <div key={currentId}>
                    <button
                      type="button"
                      className="infoAccordionHeader"
                      onClick={() => toggle(currentId)}
                      aria-expanded={isOpen}
                    >
                      {q}
                    </button>
                    {isOpen && (
                      <div className="infoAccordionContent">
                        <p>{a}</p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          ))}
        </div>

        <div className="infoSection">
          <h2>{t('infoPages.helpCenter.stillNeedHelp')}</h2>
          <p>
            {t('infoPages.helpCenter.stillNeedHelpDesc')}{' '}
            <Link to="/contact" className="infoLink">
              {t('infoPages.helpCenter.contactUs')}
            </Link>{' '}
            {t('infoPages.helpCenter.andWillGetBack')}
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default HelpCenter;
